// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"d391d54f","419":"a0d51c47","453":"652b6833","455":"8f97ca09","868":"0a16a93e","977":"c36a9456"}[chunkId] + ".chunk.js";
};